module.exports = {
  VALUE_CHANGE_MODE: {
    FIXED_VALUE: 0,
    MODIFIABLE: 1
  },
  DISCOUNT_MODES: {
    FIXED_VALUE_UNTIL_THE_DATES_INFORMED: 'FIXED_VALUE_UNTIL_THE_DATES_INFORMED',
    PERCENTAGE_DATE_REPORTED: 'PERCENTAGE_DATE_REPORTED',
    AMOUNT_PER_CALENDAR_DAY_ADVANCE: 'AMOUNT_PER_CALENDAR_DAY_ADVANCE',
    AMOUNT_ADVANCE_BUSINESS_DAY: 'AMOUNT_ADVANCE_BUSINESS_DAY',
    PERCENTAGE_ADVANCE_CURRENT_DAY: 'PERCENTAGE_ADVANCE_CURRENT_DAY',
    PERCENTAGE_ADVANCE_BUSINESS_DAY: 'PERCENTAGE_ADVANCE_BUSINESS_DAY'
  },
  ABATEMENT_MODES: {
    FIXED_VALUE: 'FIXED_VALUE',
    PERCENT: 'PERCENT'
  },
  FINE_MODES: {
    FIXED_VALUE: 'FIXED_VALUE',
    PERCENT: 'PERCENT'
  },
  INTEREST_MODES: {
    VALUE_CALENDAR_DAYS: 'VALUE_CALENDAR_DAYS',
    PERCENTAGE_PER_DAY_CALENDAR_DAYS: 'PERCENTAGE_PER_DAY_CALENDAR_DAYS',
    PERCENTAGE_PER_MONTH_CALENDAR_DAYS: 'PERCENTAGE_PER_MONTH_CALENDAR_DAYS',
    PERCENTAGE_PER_YEAR_CALENDAR_DAYS: 'PERCENTAGE_PER_YEAR_CALENDAR_DAYS',
    VALUE_WORKING_DAYS: 'VALUE_WORKING_DAYS',
    PERCENTAGE_PER_DAY_WORKING_DAYS: 'PERCENTAGE_PER_DAYWORKING_DAYS',
    PERCENTAGE_PER_MONTH_WORKING_DAYS: 'PERCENTAGE_PER_MONTH_WORKING_DAYS',
    PERCENTAGE_PER_YEAR_WORKING_DAYS: 'PERCENTAGE_PER_YEAR_WORKING_DAYS'
  }
};
